import ErrorStackParser from 'error-stack-parser';
import * as React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Grid, Icon, Text, decodeJWT, sendLog } from '@siteground/styleguide';

import { ChatLayout } from '../../components/chat-layout';
import { ChatLogo } from '../../components/chat-logo';
import { getClientToken } from '../../selectors/chat-session';

class ErrorHandler extends React.Component {
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, errorInfo) {
    const { user_id, client_id } = decodeJWT(this.props.clientToken);
    const parsedError = ErrorStackParser.parse(error);
    const parsedErrorInfo = {
      componentStack: parsedError ? JSON.stringify(parsedError) : errorInfo.componentStack
    };

    sendLog({
      error: `Chat-Error --->>> ${error}`,
      errorInfo: parsedErrorInfo,
      // uid: 'https://0.0.0.0:2001_log', // debug url
      data: JSON.stringify({
        agent: window.navigator.userAgent,
        user_id,
        client_id
      })
    });
  }

  render() {
    const { intl } = this.props;

    if (this.state.hasError) {
      return (
        <ChatLayout
          header={<ChatLogo />}
          content={
            <Grid justify="center">
              <Icon name="something-went-wrong" size="200" multicolor />
              <Text size="x-large">Oops! Something went wrong.</Text>
            </Grid>
          }
        />
      );
    }

    return this.props.children;
  }
}

const mapStoreToProps = (store) => ({
  clientToken: getClientToken(store)
});

export default connect(mapStoreToProps)(injectIntl(ErrorHandler));
